import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import CreditCard from './CreditCard';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <CreditCard path="credit_card/*" />
    </Router>
  </Container>
);
